import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAUQm9kezU3UG7pm1EPfl7nKpWSmFJvbd8",
  authDomain: "we-r-hungry.firebaseapp.com",
  projectId: "we-r-hungry",
  storageBucket: "we-r-hungry.firebasestorage.app",
  messagingSenderId: "825438697576",
  appId: "1:825438697576:web:c974a3f80d6f25490763dd",
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, "us-west1");

export async function ensureAnonymousSession() {
  if (auth.currentUser) return auth.currentUser;
  const credential = await signInAnonymously(auth);
  return credential.user;
}
